module.exports = __webpack_public_path__ + "img/icon-confirm.3945da7d.svg";